import { render, staticRenderFns } from "./Box.vue?vue&type=template&id=b1d75cd6&scoped=true"
import script from "./Box.vue?vue&type=script&lang=ts"
export * from "./Box.vue?vue&type=script&lang=ts"
import style0 from "./Box.vue?vue&type=style&index=0&id=b1d75cd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d75cd6",
  null
  
)

export default component.exports